import * as tslib_1 from "tslib";
import { FormGroup } from '@angular/forms';
import { FormComponent, } from '@components/ui-upsert-page/ui-form.component';
import { StopStrategy } from '@models';
import { STOP_DAYS_MAX, STOP_HOURS_MAX, STOP_MINUTES_MAX, } from '../trigger.upsert.page.models';
var StopAfterComponent = /** @class */ (function (_super) {
    tslib_1.__extends(StopAfterComponent, _super);
    function StopAfterComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.StopStrategy = StopStrategy;
        _this.disabled = false;
        return _this;
    }
    Object.defineProperty(StopAfterComponent.prototype, "stopDaysMax", {
        get: function () { return STOP_DAYS_MAX; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StopAfterComponent.prototype, "stopHoursMax", {
        get: function () { return STOP_HOURS_MAX; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StopAfterComponent.prototype, "stopMinutesMax", {
        get: function () { return STOP_MINUTES_MAX; },
        enumerable: true,
        configurable: true
    });
    StopAfterComponent.prototype.changedStopJob = function (toggle) {
        var stopStrategy = this.getField('stopStrategy');
        var stopFields = this.getFields('stopDays', 'stopHours', 'stopMinutes');
        stopStrategy.setValue(toggle ?
            StopStrategy.SoftStop :
            null);
        if (toggle) {
            stopFields.forEach(function (f) { return f.enable(); });
        }
        else {
            stopFields.forEach(function (f) { return f.disable(); });
        }
    };
    return StopAfterComponent;
}(FormComponent));
export { StopAfterComponent };
